import { defineStore } from 'pinia'
import type { ToastMessageOptions } from 'primevue'

type State = {
  messages: Array<ToastMessageOptions>
}

/**
 * This store make it possible to use toast in pinia store actions
 */
export const useToastStore = defineStore('toast', {
  state: (): State => {
    return {
      messages: []
    }
  },
  getters: {
    hasMessages(state) {
      return state.messages.length > 0
    }
  },
  actions: {
    add(message: ToastMessageOptions) {
      this.messages.push(message)
    },
    success(message: string) {
      this.add({
        severity: 'success',
        summary: 'Success',
        detail: message,
        life: 3000
      })
    },
    info(message: string, summary: string = 'Info') {
      this.add({
        severity: 'info',
        summary,
        detail: message,
        life: 8000
      })
    },
    warn(message: string, summary: string = 'Warning') {
      this.add({
        severity: 'warn',
        summary,
        detail: message,
        life: 8000
      })
    },
    error(error: ApiError) {
      this.add({
        severity: 'error',
        summary: 'Error',
        detail: error?._error || error.message
      })
    },
    reset() {
      this.messages = []
    }
  }
})
